import { useNavigate } from "react-router-dom";
// import "../scss/postMedia.scss";

const PostMedia = ({ images, postId }) => {
    const navigate = useNavigate();

    const parseImages = (imgs) => {
        if (!imgs) return [];

        if (Array.isArray(imgs)) return imgs;

        try {
            const parsed = JSON.parse(imgs);
            return Array.isArray(parsed) ? parsed : [imgs];
        } catch (e) {
            return [imgs];
        }
    };

    const imageList = parseImages(images);
    if (imageList.length === 0) return null;

    const displayImages = imageList.slice(0, 4);
    const remainingCount = imageList.length - 4;
    const gridClass = `grid-${Math.min(imageList.length, 4)}`;

    const handleImageClick = (e, index) => {
        e.preventDefault();
        e.stopPropagation();
        navigate(`/post/${postId}?index=${index}`);
    };

    return (
        <div className={`media-grid ${gridClass}`}>
            {displayImages.map((imgSrc, index) => {
                const finalSrc = imgSrc.startsWith("http") ? imgSrc : "/upload/" + imgSrc;
                const isVideo = finalSrc.match(/\.(mp4|webm|ogg)$/i);

                if (index === 3 && remainingCount > 0) {
                    return (
                        <div 
                            key={index} 
                            className="media-item overlay-container" 
                            onClick={(e) => handleImageClick(e, index)}
                        >
                            {isVideo 
                                ? <video src={finalSrc} muted /> 
                                : <img src={finalSrc} alt="" 
                            />}

                            <div className="overlay-count">
                                +{remainingCount}
                            </div>
                        </div>
                    );
                }

                return (
                    <div 
                        key={index} 
                        className="media-item" 
                        onClick={(e) => handleImageClick(e, index)}
                    >
                        {isVideo 
                            ? <video src={finalSrc} controls muted /> 
                            : <img src={finalSrc} alt="" 
                            />
                        }
                    </div>
                );
            })}
        </div>
    );
};

export default PostMedia;